/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/layouts/index'),
    redirect: '/ai',
    meta: {
      title: '首页',
      keepAlive: false
    },
    children: [
      {
        path: '/home',
        redirect: '/ai',
        // name: 'Home',
        // component: () => import('@/views/home/index'),
        // meta: { title: '首页', keepAlive: true, TabbarShow: true }
      },
      // {
      //   path: '/enterprise_match',
      //   name: 'EnterpriseMatch',
      //   component: () => import('@/views/EnterpriseMatch/index'),
      //   meta: { title: '企业匹配', keepAlive: true, TabbarShow: false }
      // },
      // {
      //   path: '/EnterpriseMatchCopy',
      //   name: 'EnterpriseMatchCopy',
      //   component: () => import('@/views/EnterpriseMatch/indexcopy'),
      //   meta: { title: '企业匹配', keepAlive: true, TabbarShow: true }
      // },
      // {
      //   path: '/mall',
      //   name: 'Mall',
      //   component: () => import('@/views/mall/index'),
      //   meta: { title: '严选商城', keepAlive: false, TabbarShow: false }
      // },
      // {
      //   path: '/mall/detail',
      //   name: 'MallDetail',
      //   component: () => import('@/views/mall/detail'),
      //   meta: { title: '服务机构信息', keepAlive: false, TabbarShow: false }
      // },
      // {
      //   path: '/setup',
      //   name: 'Setup',
      //   component: () => import('@/views/setup/index'),
      //   meta: { title: '我的', keepAlive: true, TabbarShow: true },
      // },
      {
        path: '/search/:id',
        name: 'Search',
        component: () => import('@/views/searchMatching/index'),
        meta: { title: '精准匹配', keepAlive: false, TabbarShow: false },
      },
      // {
      //   path: '/search_result',
      //   name: 'SearchResult',
      //   component: () => import('@/views/searchMatching/result'),
      //   // component: () => import('@/views/searchMatching/resultOld'),
      //   meta: { title: '精准匹配结果', keepAlive: false, TabbarShow: false },
      // },
      {
        path: '/search_two',
        name: 'SearchTwo',
        component: () => import('@/views/searchMatching/twoindex'),
        // component: () => import('@/views/searchMatching/resultOld'),
        meta: { title: '申报', keepAlive: false, TabbarShow: false },
      },
      // {
      //   path: '/notice_search',
      //   name: 'NoticeSearch',
      //   component: () => import('@/views/home/noticeSearch'),
      //   meta: { title: '精准匹配结果', keepAlive: false, TabbarShow: false },
      // },
      //
      // {
      //   path: '/detail',
      //   name: 'Detail',
      //   component: () => import('@/views/searchMatching/detail'),
      //   meta: { title: '政策内容', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/policy_query/index',
      //   name: 'PolicyQuery',
      //   component: () => import('@/views/policyQuery/index'),
      //   meta: { title: '政策内容', keepAlive: true, TabbarShow: false },
      // },
      // {
      //   path: '/policy_query/detail',
      //   name: 'PolicyQueryDetail',
      //   component: () => import('@/views/searchMatching/detail'),
      //   meta: { title: '政策内容', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/notify/detail',
      //   name: 'NotifyDetail',
      //   component: () => import('@/views/policyQuery/detailNotify'),
      //   meta: { title: '通知公告详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/declare/detail',
      //   name: 'DeclareDetail',
      //   component: () => import('@/views/policyQuery/detailDeclare'),
      //   meta: { title: '政策申报详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/policy/detail',
      //   name: 'PolicyDetail',
      //   component: () => import('@/views/policyQuery/detailPolicy'),
      //   meta: { title: '政策文件详情', keepAlive: false, TabbarShow: false },
      // },
      {
        path: '/article/detail',
        name: 'ArticleDetail',
        component: () => import('@/views/policyQuery/articleDetailv3'),
        meta: { title: '详情', keepAlive: false, TabbarShow: false },
      },
      {
        path: '/project_query/index',
        name: 'ProjectQuery',
        component: () => import('@/views/projectQuery/index'),
        meta: { title: '立项查询', keepAlive: false, TabbarShow: false },
      },
      {
        path: '/project_query/result',
        name: 'ProjectQueryResult',
        component: () => import('@/views/projectQuery/result'),
        meta: { title: '立项查询结果', keepAlive: false, TabbarShow: false },
      },
      // {
      //   path: '/order',
      //   name: 'Order',
      //   component: () => import('@/views/order/index'),
      //   meta: { title: '我的订单', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/order/detail',
      //   name: 'OrderDetail',
      //   component: () => import('@/views/order/detail'),
      //   meta: { title: '订单详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/collect',
      //   name: 'Collect',
      //   component: () => import('@/views/collect/index'),
      //   meta: { title: '我的收藏', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/subscribe',
      //   name: 'SubscribeIndex',
      //   component: () => import('@/views/subscribe/index'),
      //   meta: { title: '我的订阅', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/subscribe/list',
      //   name: 'SubscribeList',
      //   component: () => import('@/views/subscribe/list'),
      //   meta: { title: '订阅列表', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/subscribe/detail',
      //   name: 'SubscribeDetail',
      //   component: () => import('@/views/searchMatching/detail'),
      //   meta: { title: '订阅详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/matters',
      //   name: 'MattersIndex',
      //   component: () => import('@/views/matters/index'),
      //   meta: { title: '我的事项', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/matters/evaluate/detail',
      //   name: 'MattersEvaluateDetail',
      //   component: () => import('@/views/matters/evaluate/detail'),
      //   meta: { title: '服务评价', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/vip',
      //   name: 'Vip',
      //   component: () => import('@/views/vip/index'),
      //   meta: { title: 'VIP会员', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/vip/pay',
      //   name: 'VipPay',
      //   component: () => import('@/views/vip/pay'),
      //   meta: { title: '确认发票信息', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/purchase',
      //   name: 'Purchase',
      //   component: () => import('@/views/purchase/index'),
      //   // component: () => import('@/views/purchase/indexOld'),
      //   meta: { title: '确认企业信息', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/qrcode',
      //   name: 'Qrcode',
      //   component: () => import('@/views/qrcode/index'),
      //   meta: { title: '政小睿', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/coupon',
      //   name: 'Coupon',
      //   component: () => import('@/views/coupon/index'),
      //   meta: { title: '科服券', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/coupon/use_detail',
      //   name: 'CouponUseDetail',
      //   component: () => import('@/views/coupon/useDetail'),
      //   meta: { title: '科服券详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/coupon/company_certificate',
      //   name: 'CouponCompanyCertificate',
      //   component: () => import('@/views/coupon/companyCertificate'),
      //   meta: { title: '科服券详情', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/coupon/share',
      //   name: 'CouponShare',
      //   component: () => import('@/views/coupon/share'),
      //   meta: { title: '科服券', keepAlive: false, TabbarShow: false },
      // },
      // {
      //   path: '/empty/index',
      //   name: 'Empty',
      //   component: () => import('@/views/empty/index'),
      //   meta: { title: '', keepAlive: false, TabbarShow: false },
      // },
      {
        path: '/ai/chat',
        name: 'AIChat',
        component: () => import('@/views/ai/chat'),
        meta: { title: 'AI聊天', keepAlive: true, TabbarShow: false }
      },
      {
        path: '/ai',
        name: 'AIIndex',
        component: () => import('@/views/ai/index'),
        meta: { title: 'AI首页', keepAlive: true, TabbarShow: false }
      },
      {
        path: '/ai/project_query',
        name: 'AIProjectQuery',
        component: () => import('@/views/ai/projectQuery'),
        meta: { title: 'AI立项查询', keepAlive: true, TabbarShow: false }
      },
      {
        path: '/ai/enterprise_match',
        name: 'AIEnterpriseMatch',
        component: () => import('@/views/ai/enterpriseMatch'),
        meta: { title: 'AI企业匹配', keepAlive: true, TabbarShow: false }
      },
    ]
  }
]
